import { render, staticRenderFns } from "./DeltaNameScreeningRejected.vue?vue&type=template&id=51497e76"
import script from "./DeltaNameScreeningRejected.vue?vue&type=script&lang=js"
export * from "./DeltaNameScreeningRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports